<div data-testid="third-party-after-page" class="p-4 flex-table-page">
  <h2 class="text-2xl font-semibold text-gray-800 mb-3 flex-table-header">
    {{ "third_party.after_sales.title" | translate }}
  </h2>

  <!-- Search Form (reusing shared search form) -->
  <app-search-form
    data-testid="third-party-after-search-form"
    [orderSources]="platformStatusOptions()"
    [salesChannels]="salesChannels()"
    [buyerNotesOptions]="refundStatusOptions()"
    [giftOptions]="flowStatusOptions()"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions">
      <app-status-filter
        [primaryButton]="primaryButton"
        [secondaryButton]="secondaryButton"
        (primaryButtonClick)="onCreate()"
        (secondaryButtonClick)="onDownload()"
      ></app-status-filter>
    </div>
  </app-search-form>

  <!-- Status Filter with Action Buttons -->
  <div class="mb-2 flex-table-header">
    <app-status-filter
      [statusOptions]="statusOptions"
      (statusChange)="onStatusChange($event)"
    ></app-status-filter>
  </div>

  <!-- Data Table -->
  <div class="flex-table-section">
    <app-data-table
      data-testid="third-party-after-table"
      [dataSource]="orders()"
      [columns]="tableColumns"
      [rows]="pageSize()"
      [first]="first()"
      [totalRecords]="totalRecords()"
      scrollHeight="flex"
      [loading]="loading()"
      [selection]="selectedOrders()"
      [hasCheckColumn]="true"
      (selectionChange)="onSelectionChange($event)"
      (pageChange)="onPageChange($event)"
    ></app-data-table>
  </div>
</div>
